import React from 'react'
import { Fragment } from 'react';
import { DATE_FORMAT } from '../../../../utils/config';

const ProjectRow = ({data}) => {
    const isDateFormat=(fromdata,todata)=> {
      let dateFrom = new Date(fromdata);
      let dateTo = new Date(todata);
 
      let yearfrom = dateFrom.getFullYear();
      let dayfrom = dateFrom.getDate();
 
      let monthfrom = dateFrom.getMonth();
 
      let year = dateTo.getFullYear();
 
      let day = dateTo.getDate();
      let month = dateTo.getMonth();
 
      if (`${dayfrom.length === 1}`) dayfrom = `0${dayfrom}`;
      if (`${monthfrom.length === 1}`) monthfrom = `0${monthfrom}`;
 
      if (`${day}`.length === 1) day = `0${day}`;
      if (`${month}`.length === 1) month = `0${month}`;
 
      if (DATE_FORMAT === "DD-MM-YYYY")
        return `${dayfrom}-${monthfrom}-${yearfrom} to ${day}-${month}-${year}`;
 
      return `${month}-${day}-${year}`;
    }
     
    
     const rows = data.map( (item,index) => 
         <div  key={item.id}>
                <h6 style={{
      fontSize: "1.125rem",
      fontWeight: "bold",
      marginTop: "0.625rem",
    }}>Project {index +1}</h6>
            <h6>ProjectName &emsp; &emsp; &emsp; &emsp; &nbsp; &emsp; &nbsp;&emsp; &nbsp;&nbsp;:&emsp;  <span style={{  "font-weight": "normal"}}>{item.projectName}</span></h6>
            <h6>Customer Name&emsp; &emsp; &emsp; &nbsp;&emsp; &nbsp;&emsp; &nbsp;&nbsp;&nbsp;:&emsp; <span style={{  "font-weight": "normal"}}>{item.customerName}</span></h6> 
            <h6>Skill Set &emsp; &emsp; &emsp; &emsp;&emsp;&emsp;&nbsp;&nbsp;&emsp; &nbsp;&emsp; &nbsp;&nbsp; &nbsp;:&emsp;  <span style={{  "font-weight": "normal"}}>{item.skillSet}</span></h6>
            <h6>Tools&Technologies &emsp;  &nbsp;&nbsp;&nbsp;&emsp; &nbsp;&emsp; &nbsp; &nbsp;:&emsp; <span style={{  "font-weight": "normal"}}>{item.toolsAndTechnologies}</span></h6>
            <h6>Responsibilities &emsp; &emsp; &emsp;&nbsp;&nbsp;&emsp; &nbsp;&emsp; &nbsp;&nbsp; :&emsp; <span style={{  "font-weight": "normal"}}>{item.responsibilities}</span></h6>
            <h6>Duration &emsp; &emsp; &emsp; &emsp; &emsp;&emsp; &emsp; &nbsp;&emsp; &nbsp;&nbsp;:&emsp; <span style={{  "font-weight": "normal"}}>{isDateFormat(item.fromDate,item.toDate)}</span></h6>
             
         </div>
         
     )
     
     return (<Fragment>{rows}</Fragment> )
 };

export default ProjectRow